import React from 'react';
import { is } from '../../../services/classify';
import { hashClass } from '../../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../context';
/**
 * Slice List Component
 * @param className {string} Additionnal CSS Classes
 * @param children {ReactNode} Children for SliceList (Slice)
 * @param transparent {boolean} Apply transparent on Slices container
 * @param selectable {boolean} List of checkable Slice
 */
const SliceList = ({ children, className, transparent, selectable, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('slices', transparent && is('transparent'), selectable && 'slice-select', className));
    return (React.createElement("div", { className: classes, ...others }, children));
};
export default SliceList;
//# sourceMappingURL=SliceList.js.map